import { Decimal } from "@syla/shared/decimal";
import React from "react";
import { Plan } from "../../types/plans/plan";
import { CardHeading } from "./CardHeading";
import { PlanAccount } from "./PlanAccount";
import { StdPlanText } from "./StdPlanText";
import { UnlockPlanOrAlternative } from "./UnlockPlanOrAlternative";
import { UpsellCardBase } from "./UpsellCardBase";
import { useUpsellAnalytics } from "./useUpsellAnalytics";

export const TransactionCapCard = ({
  recommendedPlan,
  currentPlan,
  cheaperPlan,
  account,
}: {
  recommendedPlan: Plan;
  cheaperPlan: Plan;
  currentPlan: Plan | undefined;
  account: PlanAccount;
}) => {
  useUpsellAnalytics("transactionCapExceeded", recommendedPlan.name);

  const upgradedTransactionCount = Decimal.from(
    recommendedPlan.features.transactionLimit.toString(),
  ).format({
    separateThousands: true,
  }).text;

  return (
    <UpsellCardBase
      heading={
        <CardHeading>
          {currentPlan ?
            `Increase to ${upgradedTransactionCount} transactions`
          : `Get your tax report`}
        </CardHeading>
      }
      content={
        <StdPlanText
          recommendedPlan={recommendedPlan}
          currentPlan={currentPlan}
          account={account}
          subtext={`Increase your transaction cap to cover all transactions in your account.`}
        />
      }
      actions={
        <UnlockPlanOrAlternative
          account={account}
          currentPlan={currentPlan}
          recommendedPlan={recommendedPlan}
          cheaperPlan={cheaperPlan}
        />
      }
    />
  );
};
